import {JsonConverter, JsonCustomConvert} from "json2typescript";

import {BigIntId} from "./big-int-id";
import dayjs, {Dayjs} from "./dayjs";

export const JsonPropertyEmpty = undefined as any;

/* eslint-disable max-classes-per-file */

@JsonConverter
export class DateTimeConverter implements JsonCustomConvert<Dayjs | null> {
    public serialize(date: Dayjs | null): any {
        return date === null ? date : date.toJSON();
    }
    public deserialize(date: string | null): Dayjs | null {
        return date === null ? date : dayjs(date);
    }
}

@JsonConverter
export class BigIntIdConverter implements JsonCustomConvert<BigIntId | null> {
    public serialize(id: BigIntId | null): any {
        return id === null ? id : id.value;
    }
    public deserialize(id: string | null): BigIntId | null {
        return id === null ? id : new BigIntId(id);
    }
}

@JsonConverter
export class BigIntIdArrayConverter implements JsonCustomConvert<BigIntId[] | null> {
    public serialize(ids: BigIntId[] | null): any {
        return ids === null ? ids : ids.map((x) => x.value);
    }
    public deserialize(ids: string[] | null): BigIntId[] | null {
        return ids === null ? ids : ids.map((x) => new BigIntId(x));
    }
}
